module.exports = "/_next/static/images/wirelineOperations-ac9aadf51c0429b526c04945d1ef05ef.webp";